<alaris-card>
	@if (!this.loading$.getValue() && (tRows.length === 0 && !isFiltersApplied())) {
		<ds-empty-state [alarisLoading]="loading$"
				[description]="'sources.empty_state.sub_title' | translate"
		>
			<button
					(click)="edit()"
					dsButton
					mode="main"
					size="M"
					[iconLeftProps]="{ name: 'icon-add-20', form: 'square' }"
					[disabled]="!this.user.allowed(['sources.edit'])"
			>
				{{ 'sources.add' | translate }}
			</button>
		</ds-empty-state>
	} @else {
		<app-table-management
			[refresh]="refresh.bind(this)"
			[export]="export.bind(this)"
			[alarisLoading]="exporting$ || loading$"
		>
			<button
				create
				(click)="edit()"
				dsButton
				mode="main"
				size="M"
				[iconLeftProps]="{ name: 'icon-add-20', form: 'square' }"
				[disabled]="!this.user.allowed(['sources.edit'])"
			>
				{{ 'sources.add' | translate }}
			</button>
			<div total>{{ 'sources.sources_total' | translate: { total } }}</div>

			<ng-container filters [formGroup]="filtersForm">
				<div class="filter-row">

				<ds-input placeholder="{{ 'sources.name' | translate }}" class="search" mode="plain"
						  formControlName="name">
					<ds-icon-swap slot="left" mode="disabled" iconName="icon-search-20"></ds-icon-swap>
				</ds-input>

				<ds-multi-select-dropdown-preset
						[options]="typeOptions()"
						formControlName="type"
						[selectAllBtn]="true"
						[search]="true">
					<ds-filter-item class="filter" [label]="'sources.type' | translate"
									placeholder="{{ 'gl.any' | translate }}"
									slot="trigger" [translateValue]="true">
					</ds-filter-item>
				</ds-multi-select-dropdown-preset>

				<ds-multi-select-dropdown-preset
						[options]="connectionTypeOptions"
						[selectAllBtn]="true"
						[search]="true"
						formControlName="connectionType">
					<ds-filter-item class="filter" [label]="'sources.connection_type' | translate"
									placeholder="{{ 'gl.any' | translate }}"
									slot="trigger">
					</ds-filter-item>
				</ds-multi-select-dropdown-preset>

				<ds-multi-select-dropdown-preset
						[options]="currencies()"
						formControlName="currency"
						[selectAllBtn]="true"
						[search]="true">
					<ds-filter-item class="filter" [label]="'sources.currency' | translate"
									placeholder="{{ 'gl.any' | translate }}"
									slot="trigger">
					</ds-filter-item>
				</ds-multi-select-dropdown-preset>
				@if (isFiltersApplied()) {
					<button
							dsButton
							[mode]="'main'"
							[view]="'flat-secondary'"
							type="button"
							(click)="resetFilters()"
							size="S">
						{{ 'actions.clear' | translate }}
					</button>
				}
				</div>

			</ng-container>
		</app-table-management>
		<ds-table
				[clickRowHandler]="edit.bind(this)"
				[rowActions]="dropdownActions"
				[showSpinnerLoader]="!!(loading$ | async)"
				[tHeaders]="fieldsService.tHeaders()"
				[rowId]="'sourceId'"
				[tRows]="tRows"
				[templates]="{ name: nameTemplate, huntStop: huntStopTemplate, currencyName: currencyTemplate }"
		>
				<ds-no-data-found
						slot="empty-state"
						[description]="'sources.empty_state.no_data' | translate"
				>
					<button
							(click)="resetFilters()"
							dsButton
							size="M"
					>
						{{ 'actions.clear_filters' | translate }}
					</button>
				</ds-no-data-found>
		</ds-table>
		<div class="footer">
			<alaris-pagination
					(page)="pageChange($event)"
					[activePage]="sourcesService.activePage"
					[hidden]="total === 0"
					[pageSizeOptions]="pageSizeOptions"
					[pageSize]="sourcesService.pageSize"
					[total]="total"
					class="pagination">
			</alaris-pagination>
		</div>
	}
</alaris-card>

<ng-template #nameTemplate [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div style="display: flex; align-items: center; gap: 8px">
		<ds-icon-swap slot="left" mode="accent" iconName="icon-source-24"></ds-icon-swap>
		<span>{{ data.name }}</span>
	</div>
</ng-template>

<ng-template #huntStopTemplate [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	@switch (data.huntStop) {
		@case ('DISABLED') {
			<span>{{ 'sources.huntstop.disabled' | translate }}</span>
		}
		@case ('ON_TIMEOUT') {
			<span>{{ 'sources.huntstop.on_source_timeout' | translate }}</span>
		}
		@case ('ON_FAILED_RESPONSE') {
			<span>{{ 'sources.huntstop.on_failed_response' | translate }}</span>
		}
		@case ('UNCONDITIONAL') {
			<span>{{ 'sources.huntstop.unconditional' | translate }}</span>
		}
	}
</ng-template>

<ng-template #currencyTemplate [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<span>{{ getCurrencyDisplayName(data) }}</span>
</ng-template>
